import { UserAnalyticsResultModel } from '../../Login/models/UserModel';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import UserModel from '../../Login/models/UserModel';
import { OrderDirection } from '../../Datatable/OrderDirection';
import BackupFileModel from '../models/BackupFileModel';

interface databaseBackupState {
    databaseBackupFiles: BackupFileModel[],
    orderBy: string,
    orderDirection: OrderDirection
}

const initialState: databaseBackupState = {
    databaseBackupFiles: [],
    orderBy: "updatedDate",
    orderDirection: OrderDirection.Desc,
}

export const DatabaseBackupSlice = createSlice({
    name: "DatabaseBackupS",
    initialState,
    reducers: {
        setDatabaseBackupFiles: (state, action: PayloadAction<BackupFileModel[]>) => {
            state.databaseBackupFiles = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
    }
});

export const databaseBackupSelector = createSelector(
    (state: RootState) => state.databaseBackup,
    (data) => data
);

export const {
    setDatabaseBackupFiles,
    setOrderBy,
    setOrderDirection
} = DatabaseBackupSlice.actions;

export default DatabaseBackupSlice.reducer;